export const llmPromptsKeys = {
  all: [{ module: 'llmPrompts' }] as const,
  prompts: () => [{ ...llmPromptsKeys.all[0], scope: 'prompts' }] as const,
  promptDetails: () => [{ ...llmPromptsKeys.all[0], scope: 'promptDetail' }] as const,
  promptDetail: (slug: string) => [{ ...llmPromptsKeys.promptDetails()[0], slug }] as const,
  openAiModels: () => [{ ...llmPromptsKeys.all[0], scope: 'openAiModels' }] as const,
};
